import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import Logo from "./Logo";
import { NAV_LINKS, CONTACT } from "../mock";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      id="top"
      className={`fixed top-0 left-0 right-0 z-50 bg-white transition-all duration-300 ${
        scrolled
          ? "shadow-[0_6px_24px_rgba(27,43,69,0.08)] py-3"
          : "border-b border-[#efe9df] py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-serif-nav text-[18px] font-semibold text-[#1b2b45] relative after:absolute after:left-0 after:-bottom-1.5 after:h-[2px] after:w-0 after:bg-[#c79a5b] after:transition-all after:duration-300 hover:after:w-full hover:text-[#c79a5b] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href="#kontakt"
            className="font-serif-nav inline-flex items-center gap-2 bg-[#c79a5b] hover:bg-[#b3854a] text-[#1b2b45] text-[16px] font-bold uppercase tracking-[0.08em] px-7 py-3 rounded-none transition-colors"
          >
            Nezávazná poptávka
          </a>
        </div>

        <button
          className="lg:hidden text-[#1b2b45]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#f7f4ee] border-t border-[#e4ddd0] mt-3 px-5 py-4 shadow-lg">
          <nav className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-3 text-[15px] font-semibold text-[#1b2b45] border-b border-[#e4ddd0] last:border-0"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#kontakt"
              onClick={() => setOpen(false)}
              className="mt-4 inline-flex items-center justify-center gap-2 bg-[#c79a5b] text-[#1b2b45] text-[13px] font-bold uppercase tracking-wider px-6 py-3 rounded-none"
            >
              <Phone size={16} /> {CONTACT.phone}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
